module.exports = __webpack_public_path__ + "static/media/p-intro-1.d70f86c0.png";